@file:OptIn(InternalResourceApi::class)

package portalvv.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/portalvv.shared.generated.resources/"

@delegate:ResourceContentHash(532_340_310)
internal val Res.string.operational_people_legend_terminations: StringResource by lazy {
      StringResource("string:operational_people_legend_terminations", "operational_people_legend_terminations", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 43961, 58),
      ))
    }

@delegate:ResourceContentHash(-1_863_450_808)
internal val Res.string.operational_people_legend_turnover: StringResource by lazy {
      StringResource("string:operational_people_legend_turnover", "operational_people_legend_turnover", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44020, 58),
      ))
    }

@delegate:ResourceContentHash(-380_146_834)
internal val Res.string.operational_people_legend_vacancies: StringResource by lazy {
      StringResource("string:operational_people_legend_vacancies", "operational_people_legend_vacancies", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44079, 51),
      ))
    }

@delegate:ResourceContentHash(21_004_329)
internal val Res.string.operational_people_movements_title: StringResource by lazy {
      StringResource("string:operational_people_movements_title", "operational_people_movements_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44131, 70),
      ))
    }

@delegate:ResourceContentHash(-11_686_722)
internal val Res.string.operational_people_payroll_title: StringResource by lazy {
      StringResource("string:operational_people_payroll_title", "operational_people_payroll_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44202, 64),
      ))
    }

@delegate:ResourceContentHash(-1_955_927_937)
internal val Res.string.operational_people_staff_vacancies_title: StringResource by lazy {
      StringResource("string:operational_people_staff_vacancies_title", "operational_people_staff_vacancies_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44267, 92),
      ))
    }

@delegate:ResourceContentHash(1_852_702_258)
internal val Res.string.operational_people_table_title: StringResource by lazy {
      StringResource("string:operational_people_table_title", "operational_people_table_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44360, 70),
      ))
    }

@delegate:ResourceContentHash(2_513_789)
internal val Res.string.operational_period_from: StringResource by lazy {
      StringResource("string:operational_period_from", "operational_period_from", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44431, 35),
      ))
    }

@delegate:ResourceContentHash(-890_202_581)
internal val Res.string.operational_period_label: StringResource by lazy {
      StringResource("string:operational_period_label", "operational_period_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44467, 44),
      ))
    }

@delegate:ResourceContentHash(-687_030_632)
internal val Res.string.operational_period_mode_custom: StringResource by lazy {
      StringResource("string:operational_period_mode_custom", "operational_period_mode_custom", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44512, 58),
      ))
    }

@delegate:ResourceContentHash(404_857_701)
internal val Res.string.operational_period_mode_month: StringResource by lazy {
      StringResource("string:operational_period_mode_month", "operational_period_mode_month", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44571, 45),
      ))
    }

@delegate:ResourceContentHash(-174_985_268)
internal val Res.string.operational_period_mode_total: StringResource by lazy {
      StringResource("string:operational_period_mode_total", "operational_period_mode_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44617, 45),
      ))
    }

@delegate:ResourceContentHash(2_498_439)
internal val Res.string.operational_period_mode_year: StringResource by lazy {
      StringResource("string:operational_period_mode_year", "operational_period_mode_year", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44663, 40),
      ))
    }

@delegate:ResourceContentHash(-1_599_244_041)
internal val Res.string.operational_period_to: StringResource by lazy {
      StringResource("string:operational_period_to", "operational_period_to", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44704, 37),
      ))
    }

@delegate:ResourceContentHash(-2_145_704_659)
internal val Res.string.operational_reject_reason: StringResource by lazy {
      StringResource("string:operational_reject_reason", "operational_reject_reason", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44742, 61),
      ))
    }

@delegate:ResourceContentHash(64_960_676)
internal val Res.string.operational_reject_title: StringResource by lazy {
      StringResource("string:operational_reject_title", "operational_reject_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44804, 60),
      ))
    }

@delegate:ResourceContentHash(-2_021_096_239)
internal val Res.string.operational_rejected_info: StringResource by lazy {
      StringResource("string:operational_rejected_info", "operational_rejected_info", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44865, 65),
      ))
    }

@delegate:ResourceContentHash(405_470_638)
internal val Res.string.operational_rejected_success: StringResource by lazy {
      StringResource("string:operational_rejected_success", "operational_rejected_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 44931, 68),
      ))
    }

@delegate:ResourceContentHash(747_749_642)
internal val Res.string.operational_responsible_director: StringResource by lazy {
      StringResource("string:operational_responsible_director", "operational_responsible_director", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45000, 52),
      ))
    }

@delegate:ResourceContentHash(1_323_502_045)
internal val Res.string.operational_responsible_manager: StringResource by lazy {
      StringResource("string:operational_responsible_manager", "operational_responsible_manager", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45053, 51),
      ))
    }

@delegate:ResourceContentHash(-1_562_419_963)
internal val Res.string.operational_row_faturamento_receita: StringResource by lazy {
      StringResource("string:operational_row_faturamento_receita", "operational_row_faturamento_receita", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45105, 55),
      ))
    }

@delegate:ResourceContentHash(1_338_867_386)
internal val Res.string.operational_row_ticket: StringResource by lazy {
      StringResource("string:operational_row_ticket", "operational_row_ticket", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45161, 38),
      ))
    }

@delegate:ResourceContentHash(-1_781_316_270)
internal val Res.string.operational_row_transportados: StringResource by lazy {
      StringResource("string:operational_row_transportados", "operational_row_transportados", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45200, 57),
      ))
    }

@delegate:ResourceContentHash(-335_733_707)
internal val Res.string.operational_satisfaction_above_meta: StringResource by lazy {
      StringResource("string:operational_satisfaction_above_meta", "operational_satisfaction_above_meta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45258, 63),
      ))
    }

@delegate:ResourceContentHash(1_907_445_137)
internal val Res.string.operational_satisfaction_below_meta: StringResource by lazy {
      StringResource("string:operational_satisfaction_below_meta", "operational_satisfaction_below_meta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45322, 63),
      ))
    }

@delegate:ResourceContentHash(-775_279_134)
internal val Res.string.operational_satisfaction_col_bad: StringResource by lazy {
      StringResource("string:operational_satisfaction_col_bad", "operational_satisfaction_col_bad", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45386, 48),
      ))
    }

@delegate:ResourceContentHash(-2_102_099_831)
internal val Res.string.operational_satisfaction_col_business_days: StringResource by lazy {
      StringResource("string:operational_satisfaction_col_business_days", "operational_satisfaction_col_business_days", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45435, 66),
      ))
    }

@delegate:ResourceContentHash(1_815_879_383)
internal val Res.string.operational_satisfaction_col_date: StringResource by lazy {
      StringResource("string:operational_satisfaction_col_date", "operational_satisfaction_col_date", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45502, 49),
      ))
    }

@delegate:ResourceContentHash(-985_535_045)
internal val Res.string.operational_satisfaction_col_excellent: StringResource by lazy {
      StringResource("string:operational_satisfaction_col_excellent", "operational_satisfaction_col_excellent", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45552, 54),
      ))
    }

@delegate:ResourceContentHash(-1_515_211_115)
internal val Res.string.operational_satisfaction_col_goal: StringResource by lazy {
      StringResource("string:operational_satisfaction_col_goal", "operational_satisfaction_col_goal", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45607, 49),
      ))
    }

@delegate:ResourceContentHash(2_519_703)
internal val Res.string.operational_satisfaction_col_good: StringResource by lazy {
      StringResource("string:operational_satisfaction_col_good", "operational_satisfaction_col_good", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45657, 45),
      ))
    }

@delegate:ResourceContentHash(687_925_576)
internal val Res.string.operational_satisfaction_col_location: StringResource by lazy {
      StringResource("string:operational_satisfaction_col_location", "operational_satisfaction_col_location", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45703, 53),
      ))
    }

@delegate:ResourceContentHash(1_144_762_475)
internal val Res.string.operational_satisfaction_col_manager: StringResource by lazy {
      StringResource("string:operational_satisfaction_col_manager", "operational_satisfaction_col_manager", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45757, 72),
      ))
    }

@delegate:ResourceContentHash(-862_219_910)
internal val Res.string.operational_satisfaction_col_meals: StringResource by lazy {
      StringResource("string:operational_satisfaction_col_meals", "operational_satisfaction_col_meals", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45830, 58),
      ))
    }

@delegate:ResourceContentHash(404_857_701)
internal val Res.string.operational_satisfaction_col_month: StringResource by lazy {
      StringResource("string:operational_satisfaction_col_month", "operational_satisfaction_col_month", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45889, 50),
      ))
    }

@delegate:ResourceContentHash(-892_238_715)
internal val Res.string.operational_satisfaction_col_participation: StringResource by lazy {
      StringResource("string:operational_satisfaction_col_participation", "operational_satisfaction_col_participation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 45940, 74),
      ))
    }

@delegate:ResourceContentHash(441_516_983)
internal val Res.string.operational_satisfaction_col_regular: StringResource by lazy {
      StringResource("string:operational_satisfaction_col_regular", "operational_satisfaction_col_regular", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46015, 56),
      ))
    }

@delegate:ResourceContentHash(1_299_763_474)
internal val Res.string.operational_satisfaction_col_satisfaction: StringResource by lazy {
      StringResource("string:operational_satisfaction_col_satisfaction", "operational_satisfaction_col_satisfaction", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46072, 73),
      ))
    }

@delegate:ResourceContentHash(-1_720_241_764)
internal val Res.string.operational_satisfaction_col_status: StringResource by lazy {
      StringResource("string:operational_satisfaction_col_status", "operational_satisfaction_col_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46146, 51),
      ))
    }

@delegate:ResourceContentHash(-1_133_344_844)
internal val Res.string.operational_satisfaction_col_total_clients: StringResource by lazy {
      StringResource("string:operational_satisfaction_col_total_clients", "operational_satisfaction_col_total_clients", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46198, 74),
      ))
    }

@delegate:ResourceContentHash(1_016_784_164)
internal val Res.string.operational_satisfaction_col_total_votes: StringResource by lazy {
      StringResource("string:operational_satisfaction_col_total_votes", "operational_satisfaction_col_total_votes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46273, 68),
      ))
    }

@delegate:ResourceContentHash(-585_176_000)
internal val Res.string.operational_satisfaction_empty: StringResource by lazy {
      StringResource("string:operational_satisfaction_empty", "operational_satisfaction_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46342, 78),
      ))
    }

@delegate:ResourceContentHash(337_464_218)
internal val Res.string.operational_satisfaction_evolution_participation: StringResource by lazy {
      StringResource("string:operational_satisfaction_evolution_participation", "operational_satisfaction_evolution_participation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46421, 96),
      ))
    }

@delegate:ResourceContentHash(-1_962_906_681)
internal val Res.string.operational_satisfaction_evolution_satisfaction: StringResource by lazy {
      StringResource("string:operational_satisfaction_evolution_satisfaction", "operational_satisfaction_evolution_satisfaction", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46518, 91),
      ))
    }

@delegate:ResourceContentHash(1_176_544_361)
internal val Res.string.operational_satisfaction_evolution_votes: StringResource by lazy {
      StringResource("string:operational_satisfaction_evolution_votes", "operational_satisfaction_evolution_votes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46610, 76),
      ))
    }

@delegate:ResourceContentHash(1_561_426_872)
internal val Res.string.operational_satisfaction_indicator_positive: StringResource by lazy {
      StringResource("string:operational_satisfaction_indicator_positive", "operational_satisfaction_indicator_positive", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46687, 79),
      ))
    }

@delegate:ResourceContentHash(-892_238_715)
internal val Res.string.operational_satisfaction_legend_participation: StringResource by lazy {
      StringResource("string:operational_satisfaction_legend_participation", "operational_satisfaction_legend_participation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46767, 77),
      ))
    }

@delegate:ResourceContentHash(1_299_763_474)
internal val Res.string.operational_satisfaction_legend_satisfaction: StringResource by lazy {
      StringResource("string:operational_satisfaction_legend_satisfaction", "operational_satisfaction_legend_satisfaction", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46845, 76),
      ))
    }

@delegate:ResourceContentHash(-125_854_104)
internal val Res.string.operational_satisfaction_legend_votes: StringResource by lazy {
      StringResource("string:operational_satisfaction_legend_votes", "operational_satisfaction_legend_votes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46922, 61),
      ))
    }

@delegate:ResourceContentHash(607_783_534)
internal val Res.string.operational_satisfaction_meta: StringResource by lazy {
      StringResource("string:operational_satisfaction_meta", "operational_satisfaction_meta", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47044, 73),
      ))
    }

@delegate:ResourceContentHash(539_106_996)
internal val Res.string.operational_satisfaction_meta_label: StringResource by lazy {
      StringResource("string:operational_satisfaction_meta_label", "operational_satisfaction_meta_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 46984, 59),
      ))
    }

@delegate:ResourceContentHash(1_588_283_744)
internal val Res.string.operational_satisfaction_not_reached: StringResource by lazy {
      StringResource("string:operational_satisfaction_not_reached", "operational_satisfaction_not_reached", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47118, 60),
      ))
    }

@delegate:ResourceContentHash(1_857_752_335)
internal val Res.string.operational_satisfaction_overall: StringResource by lazy {
      StringResource("string:operational_satisfaction_overall", "operational_satisfaction_overall", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47266, 72),
      ))
    }

@delegate:ResourceContentHash(1_575_705_326)
internal val Res.string.operational_satisfaction_overall_participation: StringResource by lazy {
      StringResource("string:operational_satisfaction_overall_participation", "operational_satisfaction_overall_participation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47179, 86),
      ))
    }

@delegate:ResourceContentHash(1_019_362_866)
internal val Res.string.operational_satisfaction_performance_title: StringResource by lazy {
      StringResource("string:operational_satisfaction_performance_title", "operational_satisfaction_performance_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47339, 86),
      ))
    }

@delegate:ResourceContentHash(-1_233_023_703)
internal val Res.string.operational_satisfaction_reached: StringResource by lazy {
      StringResource("string:operational_satisfaction_reached", "operational_satisfaction_reached", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47426, 52),
      ))
    }

@delegate:ResourceContentHash(-823_025_115)
internal val Res.string.operational_satisfaction_units_title: StringResource by lazy {
      StringResource("string:operational_satisfaction_units_title", "operational_satisfaction_units_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47479, 76),
      ))
    }

@delegate:ResourceContentHash(-1_425_830_186)
internal val Res.string.operational_save_error: StringResource by lazy {
      StringResource("string:operational_save_error", "operational_save_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47556, 86),
      ))
    }

@delegate:ResourceContentHash(-1_809_741_683)
internal val Res.string.operational_saved: StringResource by lazy {
      StringResource("string:operational_saved", "operational_saved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47643, 49),
      ))
    }

@delegate:ResourceContentHash(-1_228_235_430)
internal val Res.string.operational_staff_movement_acquired: StringResource by lazy {
      StringResource("string:operational_staff_movement_acquired", "operational_staff_movement_acquired", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47693, 59),
      ))
    }

@delegate:ResourceContentHash(705_206_525)
internal val Res.string.operational_staff_movement_col_movement: StringResource by lazy {
      StringResource("string:operational_staff_movement_col_movement", "operational_staff_movement_col_movement", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47753, 59),
      ))
    }

@delegate:ResourceContentHash(1_188_683_720)
internal val Res.string.operational_staff_movement_col_quantity: StringResource by lazy {
      StringResource("string:operational_staff_movement_col_quantity", "operational_staff_movement_col_quantity", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47813, 63),
      ))
    }

@delegate:ResourceContentHash(1_767_547_936)
internal val Res.string.operational_staff_movement_col_role: StringResource by lazy {
      StringResource("string:operational_staff_movement_col_role", "operational_staff_movement_col_role", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47877, 55),
      ))
    }

@delegate:ResourceContentHash(1_833_367_657)
internal val Res.string.operational_staff_movement_empty: StringResource by lazy {
      StringResource("string:operational_staff_movement_empty", "operational_staff_movement_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 47933, 88),
      ))
    }

@delegate:ResourceContentHash(-1_336_290_404)
internal val Res.string.operational_staff_movement_hired: StringResource by lazy {
      StringResource("string:operational_staff_movement_hired", "operational_staff_movement_hired", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48022, 56),
      ))
    }

@delegate:ResourceContentHash(532_340_218)
internal val Res.string.operational_staff_movement_terminated: StringResource by lazy {
      StringResource("string:operational_staff_movement_terminated", "operational_staff_movement_terminated", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48079, 57),
      ))
    }

@delegate:ResourceContentHash(2_061_379_493)
internal val Res.string.operational_staff_movement_title: StringResource by lazy {
      StringResource("string:operational_staff_movement_title", "operational_staff_movement_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48137, 84),
      ))
    }

@delegate:ResourceContentHash(-255_838_767)
internal val Res.string.operational_staff_movement_transferred: StringResource by lazy {
      StringResource("string:operational_staff_movement_transferred", "operational_staff_movement_transferred", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48222, 62),
      ))
    }

@delegate:ResourceContentHash(-1_700_589_201)
internal val Res.string.operational_status_approved: StringResource by lazy {
      StringResource("string:operational_status_approved", "operational_status_approved", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48285, 47),
      ))
    }

@delegate:ResourceContentHash(-1_466_765_808)
internal val Res.string.operational_status_draft: StringResource by lazy {
      StringResource("string:operational_status_draft", "operational_status_draft", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48333, 44),
      ))
    }

@delegate:ResourceContentHash(-1_720_241_764)
internal val Res.string.operational_status_label: StringResource by lazy {
      StringResource("string:operational_status_label", "operational_status_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48378, 40),
      ))
    }

@delegate:ResourceContentHash(-1_329_692_842)
internal val Res.string.operational_status_rejected: StringResource by lazy {
      StringResource("string:operational_status_rejected", "operational_status_rejected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48419, 47),
      ))
    }

@delegate:ResourceContentHash(-1_548_366_638)
internal val Res.string.operational_status_submitted: StringResource by lazy {
      StringResource("string:operational_status_submitted", "operational_status_submitted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48467, 68),
      ))
    }

@delegate:ResourceContentHash(-166_996_327)
internal val Res.string.operational_submit_message: StringResource by lazy {
      StringResource("string:operational_submit_message", "operational_submit_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48536, 138),
      ))
    }

@delegate:ResourceContentHash(-446_339_864)
internal val Res.string.operational_submit_title: StringResource by lazy {
      StringResource("string:operational_submit_title", "operational_submit_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48675, 64),
      ))
    }

@delegate:ResourceContentHash(2_009_676_803)
internal val Res.string.operational_submitted_info: StringResource by lazy {
      StringResource("string:operational_submitted_info", "operational_submitted_info", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48740, 70),
      ))
    }

@delegate:ResourceContentHash(1_686_165_126)
internal val Res.string.operational_submitted_success: StringResource by lazy {
      StringResource("string:operational_submitted_success", "operational_submitted_success", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48811, 89),
      ))
    }

@delegate:ResourceContentHash(-1_138_003_761)
internal val Res.string.operational_subtotal: StringResource by lazy {
      StringResource("string:operational_subtotal", "operational_subtotal", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48901, 40),
      ))
    }

@delegate:ResourceContentHash(-315_752_976)
internal val Res.string.operational_summary_expense: StringResource by lazy {
      StringResource("string:operational_summary_expense", "operational_summary_expense", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48942, 47),
      ))
    }

@delegate:ResourceContentHash(174_870_153)
internal val Res.string.operational_summary_result: StringResource by lazy {
      StringResource("string:operational_summary_result", "operational_summary_result", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 48990, 46),
      ))
    }

@delegate:ResourceContentHash(1_597_430_291)
internal val Res.string.operational_summary_revenue: StringResource by lazy {
      StringResource("string:operational_summary_revenue", "operational_summary_revenue", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49037, 51),
      ))
    }

@delegate:ResourceContentHash(1_469_936_197)
internal val Res.string.operational_supplier_add: StringResource by lazy {
      StringResource("string:operational_supplier_add", "operational_supplier_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49089, 44),
      ))
    }

@delegate:ResourceContentHash(136_075_216)
internal val Res.string.operational_supplier_current: StringResource by lazy {
      StringResource("string:operational_supplier_current", "operational_supplier_current", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49134, 56),
      ))
    }

@delegate:ResourceContentHash(265_005_991)
internal val Res.string.operational_supplier_edit: StringResource by lazy {
      StringResource("string:operational_supplier_edit", "operational_supplier_edit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49191, 57),
      ))
    }

@delegate:ResourceContentHash(1_172_312_708)
internal val Res.string.operational_supplier_empty: StringResource by lazy {
      StringResource("string:operational_supplier_empty", "operational_supplier_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49249, 74),
      ))
    }

@delegate:ResourceContentHash(771_223_108)
internal val Res.string.operational_supplier_installment: StringResource by lazy {
      StringResource("string:operational_supplier_installment", "operational_supplier_installment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49445, 56),
      ))
    }

@delegate:ResourceContentHash(-1_478_786_494)
internal val Res.string.operational_supplier_installment_badge: StringResource by lazy {
      StringResource("string:operational_supplier_installment_badge", "operational_supplier_installment_badge", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49324, 58),
      ))
    }

@delegate:ResourceContentHash(-1_140_444_024)
internal val Res.string.operational_supplier_installments: StringResource by lazy {
      StringResource("string:operational_supplier_installments", "operational_supplier_installments", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49383, 61),
      ))
    }

@delegate:ResourceContentHash(-1_165_837_224)
internal val Res.string.operational_supplier_new: StringResource by lazy {
      StringResource("string:operational_supplier_new", "operational_supplier_new", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49654, 52),
      ))
    }

@delegate:ResourceContentHash(1_760_355_097)
internal val Res.string.operational_supplier_new_label: StringResource by lazy {
      StringResource("string:operational_supplier_new_label", "operational_supplier_new_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49502, 74),
      ))
    }

@delegate:ResourceContentHash(2_022_011_771)
internal val Res.string.operational_supplier_new_placeholder: StringResource by lazy {
      StringResource("string:operational_supplier_new_placeholder", "operational_supplier_new_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49577, 76),
      ))
    }

@delegate:ResourceContentHash(-674_849_682)
internal val Res.string.operational_supplier_remove: StringResource by lazy {
      StringResource("string:operational_supplier_remove", "operational_supplier_remove", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49929, 59),
      ))
    }

@delegate:ResourceContentHash(550_496_829)
internal val Res.string.operational_supplier_remove_confirm: StringResource by lazy {
      StringResource("string:operational_supplier_remove_confirm", "operational_supplier_remove_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49707, 55),
      ))
    }

@delegate:ResourceContentHash(1_444_561_992)
internal val Res.string.operational_supplier_remove_message: StringResource by lazy {
      StringResource("string:operational_supplier_remove_message", "operational_supplier_remove_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49763, 95),
      ))
    }

@delegate:ResourceContentHash(558_684_533)
internal val Res.string.operational_supplier_remove_title: StringResource by lazy {
      StringResource("string:operational_supplier_remove_title", "operational_supplier_remove_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49859, 69),
      ))
    }

@delegate:ResourceContentHash(-2_090_784_709)
internal val Res.string.operational_supplier_search: StringResource by lazy {
      StringResource("string:operational_supplier_search", "operational_supplier_search", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 49989, 59),
      ))
    }

@delegate:ResourceContentHash(1_742_427_327)
internal val Res.string.operational_supplier_select: StringResource by lazy {
      StringResource("string:operational_supplier_select", "operational_supplier_select", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50275, 51),
      ))
    }

@delegate:ResourceContentHash(-1_951_879_584)
internal val Res.string.operational_supplier_select_confirm: StringResource by lazy {
      StringResource("string:operational_supplier_select_confirm", "operational_supplier_select_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50049, 59),
      ))
    }

@delegate:ResourceContentHash(181_728_107)
internal val Res.string.operational_supplier_select_label: StringResource by lazy {
      StringResource("string:operational_supplier_select_label", "operational_supplier_select_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50109, 85),
      ))
    }

@delegate:ResourceContentHash(-1_068_037_148)
internal val Res.string.operational_supplier_select_placeholder: StringResource by lazy {
      StringResource("string:operational_supplier_select_placeholder", "operational_supplier_select_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 50195, 79),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString7Resources(map: MutableMap<String, StringResource>) {
  map.put("operational_people_legend_terminations", Res.string.operational_people_legend_terminations)
  map.put("operational_people_legend_turnover", Res.string.operational_people_legend_turnover)
  map.put("operational_people_legend_vacancies", Res.string.operational_people_legend_vacancies)
  map.put("operational_people_movements_title", Res.string.operational_people_movements_title)
  map.put("operational_people_payroll_title", Res.string.operational_people_payroll_title)
  map.put("operational_people_staff_vacancies_title", Res.string.operational_people_staff_vacancies_title)
  map.put("operational_people_table_title", Res.string.operational_people_table_title)
  map.put("operational_period_from", Res.string.operational_period_from)
  map.put("operational_period_label", Res.string.operational_period_label)
  map.put("operational_period_mode_custom", Res.string.operational_period_mode_custom)
  map.put("operational_period_mode_month", Res.string.operational_period_mode_month)
  map.put("operational_period_mode_total", Res.string.operational_period_mode_total)
  map.put("operational_period_mode_year", Res.string.operational_period_mode_year)
  map.put("operational_period_to", Res.string.operational_period_to)
  map.put("operational_reject_reason", Res.string.operational_reject_reason)
  map.put("operational_reject_title", Res.string.operational_reject_title)
  map.put("operational_rejected_info", Res.string.operational_rejected_info)
  map.put("operational_rejected_success", Res.string.operational_rejected_success)
  map.put("operational_responsible_director", Res.string.operational_responsible_director)
  map.put("operational_responsible_manager", Res.string.operational_responsible_manager)
  map.put("operational_row_faturamento_receita", Res.string.operational_row_faturamento_receita)
  map.put("operational_row_ticket", Res.string.operational_row_ticket)
  map.put("operational_row_transportados", Res.string.operational_row_transportados)
  map.put("operational_satisfaction_above_meta", Res.string.operational_satisfaction_above_meta)
  map.put("operational_satisfaction_below_meta", Res.string.operational_satisfaction_below_meta)
  map.put("operational_satisfaction_col_bad", Res.string.operational_satisfaction_col_bad)
  map.put("operational_satisfaction_col_business_days", Res.string.operational_satisfaction_col_business_days)
  map.put("operational_satisfaction_col_date", Res.string.operational_satisfaction_col_date)
  map.put("operational_satisfaction_col_excellent", Res.string.operational_satisfaction_col_excellent)
  map.put("operational_satisfaction_col_goal", Res.string.operational_satisfaction_col_goal)
  map.put("operational_satisfaction_col_good", Res.string.operational_satisfaction_col_good)
  map.put("operational_satisfaction_col_location", Res.string.operational_satisfaction_col_location)
  map.put("operational_satisfaction_col_manager", Res.string.operational_satisfaction_col_manager)
  map.put("operational_satisfaction_col_meals", Res.string.operational_satisfaction_col_meals)
  map.put("operational_satisfaction_col_month", Res.string.operational_satisfaction_col_month)
  map.put("operational_satisfaction_col_participation", Res.string.operational_satisfaction_col_participation)
  map.put("operational_satisfaction_col_regular", Res.string.operational_satisfaction_col_regular)
  map.put("operational_satisfaction_col_satisfaction", Res.string.operational_satisfaction_col_satisfaction)
  map.put("operational_satisfaction_col_status", Res.string.operational_satisfaction_col_status)
  map.put("operational_satisfaction_col_total_clients", Res.string.operational_satisfaction_col_total_clients)
  map.put("operational_satisfaction_col_total_votes", Res.string.operational_satisfaction_col_total_votes)
  map.put("operational_satisfaction_empty", Res.string.operational_satisfaction_empty)
  map.put("operational_satisfaction_evolution_participation", Res.string.operational_satisfaction_evolution_participation)
  map.put("operational_satisfaction_evolution_satisfaction", Res.string.operational_satisfaction_evolution_satisfaction)
  map.put("operational_satisfaction_evolution_votes", Res.string.operational_satisfaction_evolution_votes)
  map.put("operational_satisfaction_indicator_positive", Res.string.operational_satisfaction_indicator_positive)
  map.put("operational_satisfaction_legend_participation", Res.string.operational_satisfaction_legend_participation)
  map.put("operational_satisfaction_legend_satisfaction", Res.string.operational_satisfaction_legend_satisfaction)
  map.put("operational_satisfaction_legend_votes", Res.string.operational_satisfaction_legend_votes)
  map.put("operational_satisfaction_meta", Res.string.operational_satisfaction_meta)
  map.put("operational_satisfaction_meta_label", Res.string.operational_satisfaction_meta_label)
  map.put("operational_satisfaction_not_reached", Res.string.operational_satisfaction_not_reached)
  map.put("operational_satisfaction_overall", Res.string.operational_satisfaction_overall)
  map.put("operational_satisfaction_overall_participation", Res.string.operational_satisfaction_overall_participation)
  map.put("operational_satisfaction_performance_title", Res.string.operational_satisfaction_performance_title)
  map.put("operational_satisfaction_reached", Res.string.operational_satisfaction_reached)
  map.put("operational_satisfaction_units_title", Res.string.operational_satisfaction_units_title)
  map.put("operational_save_error", Res.string.operational_save_error)
  map.put("operational_saved", Res.string.operational_saved)
  map.put("operational_staff_movement_acquired", Res.string.operational_staff_movement_acquired)
  map.put("operational_staff_movement_col_movement", Res.string.operational_staff_movement_col_movement)
  map.put("operational_staff_movement_col_quantity", Res.string.operational_staff_movement_col_quantity)
  map.put("operational_staff_movement_col_role", Res.string.operational_staff_movement_col_role)
  map.put("operational_staff_movement_empty", Res.string.operational_staff_movement_empty)
  map.put("operational_staff_movement_hired", Res.string.operational_staff_movement_hired)
  map.put("operational_staff_movement_terminated", Res.string.operational_staff_movement_terminated)
  map.put("operational_staff_movement_title", Res.string.operational_staff_movement_title)
  map.put("operational_staff_movement_transferred", Res.string.operational_staff_movement_transferred)
  map.put("operational_status_approved", Res.string.operational_status_approved)
  map.put("operational_status_draft", Res.string.operational_status_draft)
  map.put("operational_status_label", Res.string.operational_status_label)
  map.put("operational_status_rejected", Res.string.operational_status_rejected)
  map.put("operational_status_submitted", Res.string.operational_status_submitted)
  map.put("operational_submit_message", Res.string.operational_submit_message)
  map.put("operational_submit_title", Res.string.operational_submit_title)
  map.put("operational_submitted_info", Res.string.operational_submitted_info)
  map.put("operational_submitted_success", Res.string.operational_submitted_success)
  map.put("operational_subtotal", Res.string.operational_subtotal)
  map.put("operational_summary_expense", Res.string.operational_summary_expense)
  map.put("operational_summary_result", Res.string.operational_summary_result)
  map.put("operational_summary_revenue", Res.string.operational_summary_revenue)
  map.put("operational_supplier_add", Res.string.operational_supplier_add)
  map.put("operational_supplier_current", Res.string.operational_supplier_current)
  map.put("operational_supplier_edit", Res.string.operational_supplier_edit)
  map.put("operational_supplier_empty", Res.string.operational_supplier_empty)
  map.put("operational_supplier_installment", Res.string.operational_supplier_installment)
  map.put("operational_supplier_installment_badge", Res.string.operational_supplier_installment_badge)
  map.put("operational_supplier_installments", Res.string.operational_supplier_installments)
  map.put("operational_supplier_new", Res.string.operational_supplier_new)
  map.put("operational_supplier_new_label", Res.string.operational_supplier_new_label)
  map.put("operational_supplier_new_placeholder", Res.string.operational_supplier_new_placeholder)
  map.put("operational_supplier_remove", Res.string.operational_supplier_remove)
  map.put("operational_supplier_remove_confirm", Res.string.operational_supplier_remove_confirm)
  map.put("operational_supplier_remove_message", Res.string.operational_supplier_remove_message)
  map.put("operational_supplier_remove_title", Res.string.operational_supplier_remove_title)
  map.put("operational_supplier_search", Res.string.operational_supplier_search)
  map.put("operational_supplier_select", Res.string.operational_supplier_select)
  map.put("operational_supplier_select_confirm", Res.string.operational_supplier_select_confirm)
  map.put("operational_supplier_select_label", Res.string.operational_supplier_select_label)
  map.put("operational_supplier_select_placeholder", Res.string.operational_supplier_select_placeholder)
}
